/**
 * "Facturable" = el vehículo se vende con factura AFECTA a IVA, así que el
 * comprador empresa puede usar el crédito fiscal. Es el dato que más pesa al
 * vender camiones a empresas.
 *
 * Espeja `getVehicleRegimen` del portal (goautos-admin/src/utils/vehicleRegimen.ts),
 * que es la fuente de verdad del fundamento contable:
 *
 *   - consignación → la automotora sólo factura su comisión: NO es facturable
 *   - exento       → venta exenta / contrato: NO es facturable
 *   - afecto       → factura con IVA: SÍ es facturable
 *
 * `iva_exento` es `null` cuando el vehículo hereda el régimen del cliente
 * (`clients.ventas_exentas_iva`).
 */
import { vatUiOf } from './country';

export interface FacturableSource {
  is_consigned?: boolean | null;
  iva_exento?: boolean | null;
}

export const isFacturable = (
  vehicle: FacturableSource | null | undefined,
  clientSellsExempt = false
): boolean => {
  if (!vehicle) return false;
  if (vehicle.is_consigned) return false;
  const exempt = vehicle.iva_exento ?? clientSellsExempt;
  return !exempt;
};

/**
 * ¿Se ofrece el filtro "Facturable" en el sitio? Es un concepto chileno (factura
 * afecta a IVA → crédito fiscal), así que donde no hay IVA a la chilena (Brasil,
 * EE.UU.: `vatUiOf`) no se muestra ni se aplica aunque un link traiga
 * `?facturable=`. CL / CO / AR / null / desconocido: `true`, lo de siempre.
 * Por PAÍS, nunca por moneda.
 */
export const filtroFacturableDisponible = (country?: string | null): boolean =>
  vatUiOf(country);
